import { all, takeLatest } from 'redux-saga/effects';
import * as retailersActions from '../actions';
import fetchRetailers from './worker.fetchRetailers';

function* retailersSaga() {
  yield all([takeLatest([retailersActions.fetchRetailers.type], fetchRetailers)]);
}

export default retailersSaga;
